import React from 'react';
import { API } from 'aws-amplify';
import { toast } from 'react-toastify';

import reducer from './reducer';

const initialState = {
    isInitialized: false,
    isDoingAjax: true,
    headers: [],
    list: [],
    isCompressed: false,
    sortDir: 'Desc',
    sortKey: 'CreatedUTC',
};

function sortGenerator(key, _state, _newState, _headerObj) {
    let sortFunc;
    switch (_headerObj?.type) {
        case 'date':
            sortFunc = (a, b) => {
                let dateA = new Date(a[key]),
                    dateB = new Date(b[key]);
                if (dateA?.getTime() < dateB?.getTime()) {
                    return _newState?.sortDir === 'Desc' ? 1 : -1;
                } else if (dateB?.getTime() < dateA?.getTime()) {
                    return _newState?.sortDir === 'Desc' ? -1 : 1;
                } else {
                    return 0;
                }
            };
            break;
        case 'invoice-status':
            sortFunc = (a, b) => {
                let statusA = a[key]?.id,
                    statusB = b[key]?.id;
                if (statusA < statusB) {
                    return _newState?.sortDir === 'Desc' ? 1 : -1;
                } else if (statusB < statusA) {
                    return _newState?.sortDir === 'Desc' ? -1 : 1;
                } else {
                    return 0;
                }
            };
            break;
        default:
            sortFunc = (a, b) => {
                if (a[key] < b[key]) {
                    return _newState?.sortDir === 'Desc' ? 1 : -1;
                } else if (b[key] < a[key]) {
                    return _newState?.sortDir === 'Desc' ? -1 : 1;
                } else {
                    return 0;
                }
            };
    }

    return sortFunc;
};

const useDownloadDashboard = () => {
    const [state, dispatch] = React.useReducer(reducer, initialState);

    const [href, setHref] = React.useState(null);
    const downloadRef = React.useRef();

    const retrieveDownloads = async () => {
        dispatch({
            type: 'update',
            newState: {
                isDoingAjax: true,
            },
        });

        try {
            var response = await API.post('ShipyardAPI', '/downloads');

            let sortFunc = sortGenerator(state.sortKey, state, state, state.headers);

            dispatch({
                type: 'update',
                newState: {
                    unsortedList: response.files,
                    list: response.files.sort(sortFunc),
                    headers: response.headers,
                },
            });
        } catch (e) {
            console.error(e);
            toast.error('API error.');
        } finally {
            dispatch({
                type: 'update',
                newState: {
                    isInitialized: true,
                    isDoingAjax: false,
                },
            });
        }
    };

    const handleNav = async (item) => {
        let toastId = toast.loading(`Downloading ${item.Name}.`);
        dispatch({
            type: 'update',
            newState: {
                isDoingAjax: true,
            },
        });
        try {
            let response = await API.post('ShipyardAPI', '/file/download', {
                body: {
                    s3Id: item.S3ID,
                    fileName: item.Name,
                },
            });

            setHref(response.downloadURL);
            downloadRef.current?.click?.();
            toast.success(`${item.Name} successfully downloaded!`);
        } catch (e) {
            console.error(e);
            toast.error('API error.');
        } finally {
            dispatch({
                type: 'update',
                newState: {
                    isDoingAjax: false,
                },
            });
            toast.dismiss(toastId);
        }
    };

    const handleSort = (key) => {
        let sortFunc, _state;
        if(key === state.sortKey) {
            _state = {
                ...state,
                sortDir: state?.sortDir === 'Desc' ? 'Asc' : 'Desc',
            }
            sortFunc = sortGenerator(key, state, _state, state.headers);
            dispatch({
                type: 'update',
                newState: {
                    ..._state,
                    list: state.unsortedList.sort(sortFunc)
                }
            });
        } else {
            _state = {
                ...state,
                sortDir: 'Desc',
                sortKey: key,
            }

            sortFunc = sortGenerator(key, state, _state, state.headers);
            dispatch({
                type: 'update',
                newState: {
                    ..._state,
                    list: state.unsortedList.sort(sortFunc)
                }
            });
        }
    };

    const handleCompression = () => {
        dispatch({
            type: "update",
            newState: {
                isCompressed: !state?.isCompressed || false,
            }
        });
    };

    return {
        ...state,
        href,
        downloadRef,
        retrieveDownloads,
        handleSort,
        handleNav,
        handleCompression,
    };
};

export default useDownloadDashboard;
